module.exports = __webpack_public_path__ + "preloader-pdfviewer.3b19550688bb8913a4ab.gif";


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/syncfusion-javascript/Content/ej/web/common-images/pdfviewer/preloader-pdfviewer.gif
// module id = ../../../../syncfusion-javascript/Content/ej/web/common-images/pdfviewer/preloader-pdfviewer.gif
// module chunks = 2